import m from "../../../../geodata/es2015/region/world/worldRegionsLow";
window.am4geodata_region_world_worldRegionsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/worldRegionsLow.js
// module id = null
// module chunks = 